import axios from 'axios'
import baseUrl from './Base_Url/baseUrl'
import { showToast } from './toastService'

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear()
      showToast('Unauthorized user. Please login.')
      // window.location.href = 'https://sso.rajasthan.gov.in/signin'
      window.location.href = '/#/login'
    }
    if (error.response && error.response.status === 403) {
      showToast('❌ You are not allowed to access this page!')
      window.location.href = '/#/dashboard'
    }

    return Promise.reject(error)
  },
)

export default axiosInstance
